import { render, staticRenderFns } from "./SignSecondaryMarketContractBtn.vue?vue&type=template&id=6e5d4206&"
import script from "./SignSecondaryMarketContractBtn.vue?vue&type=script&lang=js&"
export * from "./SignSecondaryMarketContractBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports